import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'GlobalMinimalHeader',
})(({ brandColors, spacing, breakpoints, type, typography }, props) => ({
  logo: {
    margin: `0 ${typography.pxToRem(15)}`,
  },
  container: {
    padding: `${spacing(1)} 0`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    background: darkOrLightStyle(props)(
      brandColors.tintsHeroBlue10,
      brandColors.tintsOffWhite60
    ),
    [breakpoints.up('lg')]: {
      minHeight: typography.pxToRem(96),
    },
    minHeight: typography.pxToRem(80),
  },
  content: {
    paddingLeft: typography.pxToRem(80),
    paddingRight: typography.pxToRem(80),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    [breakpoints.up('xs')]: {
      paddingLeft: typography.pxToRem(24),
      paddingRight: typography.pxToRem(24),
    },
    [breakpoints.up('sm')]: {
      paddingLeft: typography.pxToRem(40),
      paddingRight: typography.pxToRem(40),
    },
    [breakpoints.up('md')]: {
      paddingLeft: typography.pxToRem(64),
      paddingRight: typography.pxToRem(64),
    },
    [breakpoints.up('lg')]: {
      paddingLeft: typography.pxToRem(80),
      paddingRight: typography.pxToRem(80),
    },
  },
  logoContainer: {
    color: darkOrLightStyle(props)(
      brandColors.tintsChargeBlue60,
      brandColors.mediumBlue
    ),
    ...type['14_regular'],
    [breakpoints.up('sm')]: {
      marginBottom: 'auto',
    },
  },
  phoneContainer: {
    color: darkOrLightStyle(props)(
      brandColors.tintsChargeBlue60,
      brandColors.mediumBlue
    ),
    ...type['14_medium'],
    width: '100%',
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  phoneIcon: {
    height: spacing(-1),
    width: spacing(-1),
  },
  number: {
    marginLeft: spacing(-1),
    marginRight: spacing(-1),
    '&:hover': {
      color: darkOrLightStyle(props)(
        brandColors.white,
        brandColors.primaryMain
      ),
    },
  },
  cartAndPhone: {
    display: 'flex',
    gap: typography.pxToRem(8),
  },
}));

export default useStyles;
